"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreBarChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreBarChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreBarChart, _super);
    function CoreBarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreBarChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "bar" }, this.props));
    };
    return CoreBarChart;
}(react_1.default.PureComponent));
exports.CoreBarChart = CoreBarChart;
//# sourceMappingURL=CoreBarChart.js.map